import log from 'loglevel'
import { type Partner } from '@mzc-watchover/adminapp-appsync'
import { compact, head, isNil, join, map, split } from 'lodash/fp'
import {
  ArrayInput,
  email,
  Form,
  SimpleFormIterator,
  TextInput,
  useTranslate
} from 'react-admin'
import { Button, Card, CardContent, Grid, Typography } from '@mui/material'
import { useFormContext } from 'react-hook-form'

export const ContactEdit: React.FC<{
  partner: Partial<Partner> | undefined
}> = ({ partner }) => {
  const translate = useTranslate()
  const { products } = partner ?? { products: [] }
  const { contactEmail, contactOrganization } = head(products) ?? {
    contactOrganization: null,
    contactEmail: null
  }
  if (isNil(contactEmail) || isNil(contactOrganization)) return null
  const editEmails = map((email: string) => ({ email }))(
    split(',')(contactEmail)
  )
  const transform = (editEmails: Array<{ email: string }>) => () => {
    const value = {
      contactOrganization,
      contactEmail: join(',')(
        compact(map((item: { email: string }) => item.email)(editEmails))
      )
    }
    log.info({ value })
  }
  return (
    <Card raised sx={{ width: '80%', marginBottom: '1em' }}>
      <CardContent>
        <Form
          noValidate
          mode="onChange"
          reValidateMode="onChange"
          defaultValues={{
            editEmails
          }}>
          <Grid container>
            <Grid xs={12} sx={{ mb: '0.5em' }}>
              <Typography variant="h6">
                {translate('resources.contactEdit.title')}
              </Typography>
            </Grid>
            <Grid xs={12}>
              <ArrayInput label={false} source="editEmails">
                <SimpleFormIterator disableClear disableReordering fullWidth>
                  <TextInput
                    type="email"
                    source="email"
                    fullWidth
                    label={false}
                    validate={email()}
                  />
                </SimpleFormIterator>
              </ArrayInput>
            </Grid>
          </Grid>
          <SubmitButton onSubmit={transform} />
        </Form>
      </CardContent>
    </Card>
  )
}

const SubmitButton: React.FC<{
  onSubmit: (data: Array<{ email: string }>) => () => void
}> = ({ onSubmit }) => {
  const translate = useTranslate()
  const { getValues } = useFormContext()
  const { editEmails } = getValues()
  return (
    <Button
      variant="contained"
      color="primary"
      size="large"
      sx={{ borderRadius: '10px' }}
      onClick={onSubmit(editEmails)}>
      <Typography variant="button">
        {translate('resources.contactEdit.buttons.save')}
      </Typography>
    </Button>
  )
}
